import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_CLIENTS} from 'vx/mutations'



// Contact state.
const state = {
  clients: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  clients: state => state.clients,

  getById: (state) => (id) => {
    return state.clients.find(client => client.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of clients.
   */
  getClients ({ commit }, id, payload) {
    return http.get(`/clients/list`).then(response => {
      commit(SET_CLIENTS, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the clients state.
  */
  [SET_CLIENTS] (state, clients) {
    state.clients = clients
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
